import isEmpty from 'lodash/isEmpty';
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Helmet} from 'react-helmet-async';
import IconArrowLeft from '@spothero/icons/arrow-left';
import IconLocationArrow from '@spothero/icons/location-arrow';
import Button from '@spothero/ui/button';
import SearchActions from 'search/controls/SearchActions';
import SearchInput from 'search/controls/SearchInput';
import SearchTermToggle from 'search/controls/SearchTermToggle';
import WithSearchControls from 'search/controls/WithSearchControls';
import SelectAirport from './SelectAirport';

const TabbedSearchControls = ({
    isMobile,
    isMonthly,
    isAirport,
    isValidStart,
    isSearching,
    currentSearch,
    searchString,
    isCanadaEnabled,
    onInputChange,
    onFindParkingNearMe,
    onSearchClick,
    onSubmit,
}) => {
    const [showSearchModal, setShowSearchModal] = useState(false);
    const classes = classNames('TabbedSearchControls-form', {
        'TabbedSearchControls-modal': showSearchModal,
    });
    const bodyClasses = classNames({'no-bg-scroll': showSearchModal});
    const onToggleSearchModal = () => {
        setShowSearchModal(show => !show);
    };
    const onSearchActionClick = () => {
        if (isEmpty(currentSearch)) {
            onFindParkingNearMe();
        } else {
            onSearchClick();
        }
    };
    const onAirportInputChange = evt => {
        onInputChange(evt.target.value);
    };
    const onAirportClear = () => {
        onInputChange('');
    };
    const onAirportSelect = ({label}) => {
        onInputChange(label);

        // MP: not the most ideal way to do this but without more refactoring this seemed logical
        // allow the input change to set the "currentSearch" in WithSearchControls and then execute the search on the next UI thread available
        setTimeout(() => {
            onSearchClick();
        }, 100);
    };
    const onInputSubmit = locationData => {
        // override the submit from SearchInput to not pass true so that the search executes on selection of suggestion
        onSubmit(locationData);
    };

    return (
        <section className="TabbedSearchControls">
            <Helmet>
                <body className={bodyClasses} />
            </Helmet>
            <div className={classes}>
                <header
                    className="TabbedSearchControls-modal-close"
                    onClick={onToggleSearchModal}
                >
                    <IconArrowLeft />
                </header>
                <SearchTermToggle isSearching={isSearching} includeAirport />
                <div className="TabbedSearchControls-input">
                    {isAirport ? (
                        <SelectAirport
                            focus={isMobile ? showSearchModal : true}
                            autoFocus={showSearchModal}
                            placeholder="Airport Name, Code or City"
                            searchText={currentSearch || ''}
                            showSuggestions={isMobile ? showSearchModal : true}
                            onChange={onAirportInputChange}
                            onSelect={onAirportSelect}
                            onClear={onAirportClear}
                        />
                    ) : (
                        <SearchInput
                            focus={isMobile ? showSearchModal : true}
                            autoFocus={showSearchModal}
                            isMonthly={isMonthly}
                            isSearching={isSearching}
                            searchString={searchString}
                            isCanadaEnabled={isCanadaEnabled}
                            showLabel={false}
                            onChange={onInputChange}
                            onSubmit={onInputSubmit}
                        />
                    )}
                    <SearchActions
                        isSearching={isSearching}
                        isValidStart={isValidStart}
                        onSearchClick={onSearchActionClick}
                    />
                    <div
                        className="TabbedSearchControls-modal-open"
                        onClick={onToggleSearchModal}
                    />
                </div>
                {!isAirport && (
                    <Button
                        className="TabbedSearchControls-nearby"
                        color="primary"
                        disabled={isSearching}
                        iconPosition="left"
                        onClick={onFindParkingNearMe}
                    >
                        <IconLocationArrow /> Find Parking Near Me
                    </Button>
                )}
            </div>
        </section>
    );
};

TabbedSearchControls.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    isMonthly: PropTypes.bool,
    isAirport: PropTypes.bool,
    isValidStart: PropTypes.bool,
    isSearching: PropTypes.bool,
    searchString: PropTypes.string,
    currentSearch: PropTypes.string,
    isCanadaEnabled: PropTypes.bool,
    onInputChange: PropTypes.func.isRequired,
    onFindParkingNearMe: PropTypes.func.isRequired,
    onSearchClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default WithSearchControls(TabbedSearchControls);
